import Layout from '@/layout'

export default {
  path: '/account',
  component: Layout,
  name: 'account',
  meta: { title: '资金管理', role: 1522, icon: 'capital' },
  children: [
    {
      path: 'index',
      name: 'AccountKaihuIndex',
      component: () => import('@/pages/kaihu/index'),
      meta: { title: '资金开户', role: 1523, noCache: true }
    },
    {
      path: 'kaihu-cmb',
      name: 'AccountKaihuCmb',
      hidden: true,
      component: () => import('@/pages/kaihu/cmb'),
      meta: { title: '招行开户', role: 1523, noCache: true }
    },
    // {
    //   path: 'kaihu-piaoju',
    //   name: 'AccountKaihuPiaoju',
    //   hidden: true,
    //   component: () => import('@/pages/kaihu/piaoju'),
    //   meta: { title: '票据开户', role: 1523, noCache: true }
    // },
    // {
    //   path: 'kaihu-huifu',
    //   name: 'AccountKaihuHuifu',
    //   hidden: true,
    //   component: () => import('@/pages/kaihu/huifu'),
    //   meta: { title: '汇付天下开户', role: 1523, noCache: true }
    // },
    // {
    //   path: 'kaihu-tenpay',
    //   name: 'AccountKaihuTenpay',
    //   hidden: true,
    //   component: () => import('@/pages/kaihu/tenpay'),
    //   meta: { title: '财付通开户', role: 1523, noCache: true }
    // },
    {
      path: 'kaihu-result',
      name: 'AccountKaihuResult',
      hidden: true,
      component: () => import('@/pages/kaihu/result'),
      meta: { title: '开户结果', role: 1523, noCache: true }
    },
    {
      path: 'home',
      name: 'fundAccountHome',
      component: () => import('@/pages/fund_account/home'),
      meta: { title: '资金账户', role: 1524 }
    },
    {
      path: 'withdraw',
      name: 'FundAccountWithdraw',
      hidden: true,
      component: () => import('@/pages/fund_account/withdraw'),
      meta: { title: '余额提现', role: 1524, noCache: true }
    },
    {
      path: 'withdraw/result',
      hidden: true,
      name: 'FundAccountWithdrawResult',
      component: () => import('@/pages/fund_account/withdraw-result'),
      props: true,
      meta: { title: '余额提现结果', role: 1524 }
    },
    {
      path: 'collection-settings',
      name: 'CollectionSettings',
      component: () => import('@/pages/fund_account/collection-settings'),
      meta: { title: '收款设置', role: 1682 }
    },
    {
      path: 'tenpay-account-modify',
      name: 'FundAccountTenpayAccountModify',
      hidden: true,
      component: () => import('@/pages/fund_account/tenpay-account-modify'),
      meta: { title: '更换结算账户', role: 1524, noCache: true }
    }
  ]
}
